import { NodeType, SerializedNodeWithId } from '../../types';
import { CommonDataSet } from '../common/types';
import { buildDefaultAttributes } from './utils';

export type StandCanvasDataSet = {
	url: string;
} & CommonDataSet;
export const buildStandardCanvas = (dataset: StandCanvasDataSet, nodeIdIncrementer: () => number): Array<SerializedNodeWithId> => {
	const style = `background-image:url(${dataset.url});`;
	return [ {
		type: NodeType.Element,
		id: nodeIdIncrementer(),
		tagName: 'div',
		attributes: {
			...buildDefaultAttributes('canvas', dataset, style)
		},
		childNodes: []
	} as SerializedNodeWithId ];
};

export const CanvasStyles = `
html[data-css='glutton-wmp'] div:not([data-rdcs])[data-css=canvas] {
    width: 100%;
	height: 100%;
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-position: 0% 0%;
}
`;